import { render, staticRenderFns } from "./ModalReinstallVpnServer.vue?vue&type=template&id=59647e51"
import script from "./ModalReinstallVpnServer.vue?vue&type=script&lang=js"
export * from "./ModalReinstallVpnServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports